export enum MappingActivityDestination {
  Driving = 0,
  Availability = 1,
  UnauthorizedBreaks = 2,
  Duty50 = 3,
  Duty100 = 4,
  Rest = 5,
}
